module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"expand_review":"Show more","collapse_review":"Show less","user_display_name_message_html":"This is a review by <b>%{user_display_name}</b>.","user_grade":"User Grade","author_grade":"Author Grade"}}')
  delete Component.options._Ctor
}
